import { render, staticRenderFns } from "./contactme.vue?vue&type=template&id=3d6b2ad5"
import script from "./contactme.vue?vue&type=script&lang=js"
export * from "./contactme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports